<template>
  <div>
    <div class="table-list mt20">
      <div class="spec-head">
        <div class="sp-col">规格名称</div>
        <div class="sp-col">零售价</div>
        <div class="sp-col">总库存</div>
        <div class="sp-col">规格图</div>
        <div class="sp-col">操作</div>
      </div>
      <!-- [{"jushuitanCode":"产品编码code","retailPrice":"98.89","specDetail":"794,784","aliasTitle":"别名1","sort":0",specImg:"123"}] -->
      <div class="spec-item" v-for="(it, idx) in form.specData" :key="idx">
        <el-form-item class="sp-col" :prop="`specData[${idx}].aliasTitle`" label-width="0" :rules="{required: true,message: '请填写',trigger: 'change',}">
          <el-input v-model="it.aliasTitle" placeholder="默认规格" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`specData[${idx}].retailPrice`" label-width="0" :rules="{required: true,message: '请填写',trigger: 'change',}">
          <el-input v-model="it.retailPrice" placeholder="请输入市场价" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`specData[${idx}].retailPrice`" label-width="0" :rules="{required: true,message: '请填写',trigger: 'change',}">
          <el-input v-model="it.retailPrice" placeholder="总库存" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`specData[${idx}].specImg`" label-width="0" :rules="{required: true,message: '请上传',trigger: 'change',}">
          <imageUpload v-model="form.specImg" width="32" height="32" />
        </el-form-item>
        <div class="sp-col oper-icon">
          <span>移除</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
export default {
  props: ['form'],
  components: { ImageUpload },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item--small.el-form-item.w60 {
  width: 70%;
  display: inline-block;
  vertical-align: top;
  input {
    width: 40%;
  }
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.flexs {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .oper {
    width: 300px;
    display: inline-block;
    font-size: 16px;
    span {
      padding-left: 20px;
      cursor: pointer;
    }
    .del {
      color: #e73f3f;
      padding-left: 20px;
    }
    .add {
      color: #5dbde7;
    }
  }
}
.table-list {
  border: 1px solid #e4e4e4;
  margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
</style>